import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmSpecificForm from '../../../components/forms/FirearmSpecificForm';
import { useFirearmSpecificById, useUpdateFirearmSpecific } from '../../../hooks/useFirearmSpecificApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmSpecificDTO } from '../../../services/apiClient';

const FirearmSpecificEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmSpecificById(id!);
  const updateFirearmSpecific = useUpdateFirearmSpecific();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Specifics', href: '/admin/firearmspecifics' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmSpecific.mutateAsync({ id: id!, data });
      navigate('/admin/firearmspecifics');
    } catch (error) {
      console.error('Error updating FirearmSpecific:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmspecifics"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmSpecific.Edit'
    >
        {entityData ? (
          <FirearmSpecificForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmspecifics')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmSpecificEdit;